import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
interface SpinnerProps {
  size?: number;
  thickness?: number;
  color?: "primary" | "secondary" | "inherit";
}
const Spinner: React.FC<SpinnerProps> = ({
  size = 24,
  thickness = 3.6,
  color = "primary"
}) => {
  return <Box display="flex" justifyContent="center" alignItems="center" data-sentry-element="Box" data-sentry-component="Spinner" data-sentry-source-file="index.tsx">
            <CircularProgress size={size} thickness={thickness} color={color} data-sentry-element="CircularProgress" data-sentry-source-file="index.tsx" />
        </Box>;
};
export default Spinner;